'use client';
import { Modal } from '@/components/Modal/Modal';
import { NotifsContext } from '@/contexts';
import useNavigate from '@/hooks/useNavigate';
import {
  AddEmpReq,
  AdminFormModel,
  useAddEmpMutation,
  useGetListPdvQuery,
} from '@/services/API';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { setUser } from '@/store/slices/recapSlice';
import { ISelectNumeroAgrement, ShortPdv } from '@/types';
import env from '@/utils/env';
import { useContext, useEffect, useState } from 'react';
import Form from '../form';

export default function Page() {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();
  const selectedSte = useAppSelector((state) => state.selectedSte.societe);
  const [admin, setAdmin] = useState<AdminFormModel>();
  const [addAdmin, { isLoading }] = useAddEmpMutation();
  const [pdvs, setPdvs] = useState<ISelectNumeroAgrement[]>([]);
  const {
    data: pdvsSource,
    error: getListPdvsError,
    isLoading: getListPdvsLoading,
  } = useGetListPdvQuery(selectedSte.siren);
  const { addToast } = useContext(NotifsContext);

  useEffect(() => {
    if (pdvsSource) {
      let prepData: ISelectNumeroAgrement[] = pdvsSource?.map(
        ({ bnppf_pos_id, name, partner_pos_id }: ShortPdv) =>
          ({
            bnppf_pos_id,
            name,
            added: false,
            partner_pos_id,
          } as ISelectNumeroAgrement)
      );
      setPdvs(prepData);
    }
  }, [pdvsSource]);

  useEffect(() => {
    setAdmin({
      given_name: '',
      sn: '',
      email_address: '',
      mobile: '',
      federation_id: '',
      mfa_capable: false,
      administrator_type: env().PROFIL === 'PARTENAIRE' ? 'PARTIAL' : 'GLOBAL',
    });
  }, []);

  const handleSendData = async () => {
    if (admin) {
      let administrative_seller_number_list: string[] = [];
      if (admin.administrator_type === 'PARTIAL') {
        pdvs.map((pdv) => {
          if (pdv.added)
            administrative_seller_number_list.push(pdv.bnppf_pos_id);
        });
      }
      let req: AddEmpReq = {
        ...admin,
        account_status: 'ACTIVE',
        operational_seller_number_list: [],
        supervisor: false,
        employer: selectedSte.siren,
        fin_ent: 'PF', //TODO: remplacer avec valeur reel
        administrative_seller_number_list,
        business_domain: 'DISTRIB',
      };

      addAdmin({ siren: selectedSte.siren, reqBody: req })
        .unwrap()
        .then((payload) => {
          addToast &&
            addToast({
              toastType: 'success',
              children: 'Confirmation de création.',
            });
          dispatch(
            setUser({
              given_name: payload.given_name,
              sn: payload.sn,
              email_address: payload.email_address,
              user_password: payload.user_password,
              uid: payload.uid,
            })
          );
          navigate('recap');
        })
        .catch((err) => {
          let errorMessage = `Une erreur est survenue.
          Rééssayer ultérieurement.`;
          try {
            if (err.data[0].error === 'uniqueness') {
              errorMessage = `Ce compte existe déjà dans l'annuaire.
              Veuillez vérifier les champs uniques`;
            }
          } catch (error) {}
          addToast &&
            addToast({
              toastType: 'error',
              children: errorMessage,
            });
        })
        .finally(() => setOpenedModal(false));
    }
  };

  const [openedModal, setOpenedModal] = useState(false);

  if (getListPdvsError || getListPdvsLoading) return <></>;
  if (!admin || !pdvs) return <></>;

  return (
    <>
      <Form
        admin={admin}
        title={'Nouvel administrateur'}
        pdvs={pdvs}
        setAdmin={setAdmin}
        setPdvs={setPdvs}
        primaryBtnProps={{
          children: 'Créer un nouvel administrateur',
          onClick: () => {
            setOpenedModal(true);
          },
        }}
      />
      <Modal
        primaryBtnProps={{
          loading: isLoading,
          children: 'Confirmer',
          onClick: handleSendData,
        }}
        secondaryBtnProps={{
          children: 'Annuler',
          onClick: () => setOpenedModal(false),
        }}
        title="Voulez-vous créer l'administrateur ?"
        open={openedModal}
        onClose={() => setOpenedModal(false)}
      />
    </>
  );
}
